<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page container" v-else-if="loaded" >
        
        <div class="row mt-4" >
            
            <b-form  @submit.prevent="submitOrg()" class="atlass-form col-12 mt-3" >

                <div class="col-12 border-bottom-gray pb-2 mb-3" >
                    <span class="d-inline-block " > <h2 class="h2 font-weight-bold line-height-31" > Organization details </h2> </span>
                    <span class="d-inline-block float-right" > 

                        <b-button @click="editableOrganization = !editableOrganization" v-if="!editableOrganization && loggedIn.loggedInOrganizationID == user.OrganizationID" variant="outline-secondary" class="btn btn-sm" > <font-awesome-icon :icon="['far', 'edit']" class="mr-1" />  Edit </b-button>    

                        <span v-else-if="editableOrganization" >
                            <b-button type="submit" variant="primary" class="btn btn-sm" > <font-awesome-icon :icon="['far', 'save']" class="mr-1" />  Save </b-button>    
                            <b-button @click="editableOrganization = !editableOrganization" variant="outline-secondary" class="btn btn-sm" > <font-awesome-icon :icon="['fa', 'times']" class="mr-1" />  Cancel </b-button>    
                        </span>

                    </span>
                </div>

                <div class="col-12 row form-group" >
                    <div class="col-12 col-md-4" >
                        <label for="nameInput" > NAME: </label>
                    </div>
                    <div class="col-12 col-md-8" >
                        <span v-if="!editableOrganization" class="font-weight-bold" > {{user.OrganizationName}} </span>
                        <b-form-input v-else-if="editableOrganization" id="nameInput"
                            type="text"
                            v-model="user.OrganizationName"
                            required
                            placeholder="Name">
                        </b-form-input>
                    </div>
                </div>

                <div class="col-12 row form-group" >
                    <div class="col-12 col-md-4" >
                        <label for="nameInput" > STATUS: </label>
                    </div>
                    <div class="col-12 col-md-8" >
                        <span v-if="user.OrganizationStatus == 1" class="font-weight-bold" > Active </span>
                        <span v-if="user.OrganizationStatus == 0" class="font-weight-bold" > Inactive </span>
                        <span v-if="user.OrganizationStatus == 2" class="font-weight-bold" > Blocked </span>
                    </div>
                </div>
                
                <div class="col-12 row form-group" >
                        
                    <div class="col-12 col-md-4" >
                        <label for="email" > OWNER EMAIL: </label>
                    </div>

                    <div class="col-12 col-md-8" >
                        <span class="font-weight-bold" > {{user.Email}} </span>
                    </div>

                </div>

            </b-form>
            
        </div>

        <div class="row mt-3" >
            
            <b-form  @submit.prevent="submitUser" class="atlass-form col-12 mt-3" >
                
                <div class="col-12 border-bottom-gray pb-2 mb-3" >
                    <span class="d-inline-block line-height-31" > <h2 class="h2 font-weight-bold line-height-31" > Account details </h2> </span>
                    <span class="d-inline-block float-right" > 
                        
                        <b-button @click="editableAccount = !editableAccount" v-if="!editableAccount" variant="outline-secondary" class="btn btn-sm" > <font-awesome-icon :icon="['far', 'edit']" class="mr-1" />  Edit </b-button>    
                        
                        <span v-else-if="editableAccount" >
                            <b-button type="submit" variant="primary" class="btn btn-sm" > <font-awesome-icon :icon="['far', 'save']" class="mr-1" />  Save </b-button>    
                            <b-button @click="editableAccount = !editableAccount" variant="outline-secondary" class="btn btn-sm" > <font-awesome-icon :icon="['fa', 'times']" class="mr-1" />  Cancel </b-button>    
                        </span>
                        
                    </span>
                </div>
                
                     <div class="col-12 row form-group" >
                        <div class="col-12 col-md-4" >
                            <label for="firstnameInput" > FIRSTNAME: </label>
                        </div>
                        <div class="col-12 col-md-8" >
                            <span v-if="!editableAccount" class="font-weight-bold" > {{user.Firstname}} </span>
                            <b-form-input v-else-if="editableAccount" id="firstnameInput"
                                type="text"
                                v-model="user.Firstname"
                                required
                                placeholder="Firstname">
                            </b-form-input>
                        </div>
                    </div>

                    <div class="col-12 row form-group" >
                        <div class="col-12 col-md-4" >
                            <label for="lastnameInput" > LASTNAME: </label>
                        </div>
                         <div class="col-12 col-md-8" >
                            <span v-if="!editableAccount" class="font-weight-bold" > {{user.Lastname}} </span>
                            <b-form-input v-else-if="editableAccount"  id="lastnameInput"
                                type="text"
                                v-model="user.Lastname"
                                required
                                placeholder="Lastname">
                            </b-form-input>
                        </div>
                    </div>

                    <div class="col-12 row form-group" >
                        
                        <div class="col-12 col-md-4" >
                            <label for="email" > EMAIL: </label>
                        </div>
                        
                        <div class="col-12 col-md-8" >
                            <span class="font-weight-bold" > {{user.Email}} </span>
                        </div>
                        
                    </div>

                    <div class="col-12 row form-group d-none" v-if="loggedIn.loggedInOrganizationID == user.OrganizationID"  >
                        
                        <div class="col-12 col-md-4" >
                            <label for="password" > PASSWORD: </label>
                        </div>
                        
                        <div class="col-12 col-md-8" >
                            <b-button variant="outline-secondary" @click="fModalOpen" class="btn btn-sm" >  Change password </b-button>    
                            <!--
                            <b-button variant="outline-secondary" @click="fModalOpen" class="btn btn-sm" disabled v-else-if="user.userID != org.owner.userID" >  Change password </b-button>  -->
                        </div>
                        
                    </div>
                
            </b-form>
            
        </div>
        
        <!--
        <div class="row mt-3" >
            
            <b-form  @submit.prevent="submitOrg" class="atlass-form col-12 mt-3" >
                
                <div class="col-12 border-bottom-gray pb-2 mb-3" >
                    <span class="d-inline-block line-height-31" > <h2 class="h2 font-weight-bold line-height-31" > Settings </h2> </span>
                    <span class="d-inline-block float-right" > 
                        
                        <b-button @click="editableSettings = !editableSettings" v-if="!editableSettings" variant="outline-secondary" class="btn btn-sm" > <font-awesome-icon :icon="['far', 'edit']" class="mr-1" />  Edit </b-button>    
                        
                        <span v-else-if="editableSettings" >
                            <b-button type="submit" variant="primary" class="btn btn-sm" > <font-awesome-icon :icon="['far', 'save']" class="mr-1" />  Save </b-button>    
                            <b-button @click="editableSettings = !editableSettings" variant="outline-secondary" class="btn btn-sm" > <font-awesome-icon :icon="['fa', 'times']" class="mr-1" />  Cancel </b-button>    
                        </span>
                        
                    </span>
                </div>
                
                <div class="col-12 row form-group"  >
                    <div class="col-12 col-md-4" >
                        <label for="timezoneInput" > TIMEZONE: </label>
                    </div>
                    <div class="col-12 col-md-8" >
                        <span v-if="!editableSettings" class="font-weight-bold" > {{org.settings.timezone}} </span>
                        <select v-model="org.settings.timezone" class="form-control" v-else-if="editableSettings" >
                        <option v-for="timezone in timezones" v-bind:value="timezone">
                            {{ timezone }}
                          </option>
                    </select>
                    </div>
                </div>
                
                <div class="col-12 row form-group"   >
                    <div class="col-12 col-md-4" >
                        <label for="timezoneInput" > CURRENCY: </label>
                    </div>
                    <div class="col-12 col-md-8" >
                        <span v-if="!editableSettings" class="font-weight-bold" > {{org.settings.currency}} </span>
                        <select v-model="org.settings.currency" class="form-control" v-else-if="editableSettings" >
                            <option v-for="currency in currencies" v-bind:value="currency">
                                {{ currency }}
                            </option>
                        </select>
                    </div>
                </div>
                
            </b-form>
            
        </div>
        -->
        
        <modal :modalData="modalData" :modalState="modalState" modalComponent="passwordChange" modalClass="narrow" ></modal>
        
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import modal from '@/components/modal.vue'    
import helper from '@/helpers/helpers.js';
import m from 'moment-timezone';
import jwt_decode from "jwt-decode";

export default {
    name: 'Account',
    components:{
        modal
    },
    props: {
    },
    data: function(){
        return {
            loaded: false,
            user:{},
            settings:{},
            org:{
                
            },
            password: '',
            passwordcheck: '',
            editableUser: false,
            editableAccount: false,
            editableSettings: false,
            editableOrganization: false,
            modalData: null,
            modalState: false,
            timezones: [],
            currencies: [
                "EUR", "RON", "USD"
            ],
            
            loggedIn: {}
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        this.timezones = []
        this.timezones = m.tz.names()
        
        this.loggedIn = jwt_decode(Cookies.get('user-token')).data
        
        //mysql
        this.getData()
        
    },
    beforeDestroy() {
    },
    methods: {
        fModalOpen(  ){
            this.modalState = true;
        },
        
        getData(){
            
            let params = Cookies.get('user-token');
            let headers = { 
                'Content-Type': 'application/json;charset=utf-8', 
                'Access-Control-Allow-Headers': "*",  
                'Access-Control-Allow-Origin': "*",  
                'Access-Control-Allow-Credentials': "true",  
                "X-Auth": params 
            };
            
            axios({ method: 'POST', url: process.env.ROOT_API+'/api/account/get.php', headers: headers })
            .then(resp => {
                //console.log(resp)
                let r = resp.data;
                
                if( resp.status != 200 || r.status != 200 ){

                    

                }else{
                    
                    this.user = resp.data.data[0]
                    this.loaded = true
                    
                }

            })
            
        },
        
        formatData(unix){
            return this.$moment.unix(unix).format( 'MMM D, HH:mm' )
        },
        submitOrg(){
            //console.log( this.user )
            
            let params = Cookies.get('user-token');
            let headers = { 
                'Content-Type': 'application/json;charset=utf-8', 
                'Access-Control-Allow-Headers': "*",  
                'Access-Control-Allow-Origin': "*",  
                'Access-Control-Allow-Credentials': "true",  
                "X-Auth": params 
            };
            
            let payload = {
                organizationName : this.user.OrganizationName
            }
                        
            axios({ method: 'POST', url: process.env.ROOT_API+'/api/account/updateOrganization.php', headers: headers, data: btoa( JSON.stringify( payload ) ) })
            .then(resp => {
                //console.log(resp)
                let r = resp.data;
                
                if( resp.status != 200 || r.status != 200 ){

                    

                }else{
                    
                    this.$toast.success({
                        title:'Success',
                        message: 'Changed saved'
                    })
                    
                    this.editableOrganization = false
                    this.loaded = true
                    
                }

            })
            
        },
        submitUser(){
            //console.log( this.org )
            
            let params = Cookies.get('user-token');
            let headers = { 
                'Content-Type': 'application/json;charset=utf-8', 
                'Access-Control-Allow-Headers': "*",  
                'Access-Control-Allow-Origin': "*",  
                'Access-Control-Allow-Credentials': "true",  
                "X-Auth": params 
            };
            
            let payload = {
                Email : this.user.Email,
                Firstname : this.user.Firstname,
                Lastname : this.user.Lastname
            }
                        
            axios({ method: 'POST', url: process.env.ROOT_API+'/api/account/updateAccount.php', headers: headers, data: btoa( JSON.stringify( payload ) ) })
            .then(resp => {
                //console.log(resp)
                let r = resp.data;
                
                if( resp.status != 200 || r.status != 200 ){

                    

                }else{
                    
                    this.$toast.success({
                        title:'Success',
                        message: 'Changed saved'
                    })
                    
                    this.editableAccount = false
                    this.loaded = true
                    
                }

            })
            
        },

    },
    watch: {
        ID: function(){
            this.docID = this.ID
            this.get_data();
            
            this.$refs.tags.$el.click()
            
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >

    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
</style>



// WEBPACK FOOTER //
// src/templates/settings/Account.vue